import { ConfigService } from '@flatfile/shared-ui'

export function initializeConfigService(): Promise<void> {
  window.flatfile = window.flatfile || {}
  window.flatfile.configService = new ConfigService()
  const { hostname, pathname } = window.location

  // Determine the correct prefix based on current path and hostname
  // If we're already in a /dashboard path or not on localhost, use /dashboard prefix
  const configFile =
    hostname.includes('pr-') || hostname.includes('preview')
      ? `docker.localhost`
      : hostname.includes('localhost')
        ? `localhost`
        : hostname
  const prefix = hostname === 'localhost' && !pathname.startsWith('/dashboard') ? '' : '/dashboard'
  const configUrl = `${prefix}/config/${configFile}.config.js`
  return window.flatfile.configService.loadConfig(configUrl)
}
